export const baseProjectIds = Object.freeze([
  '929980a8-32fc-4ae7-a66f-dddb3ae4912c',
  'a0fcd798-9ddf-42e5-8205-17158d4bf5bb',
  '640b1583-cbc9-4718-b20c-31041351c62c',
  '2f80c958-3bc4-4f47-8e97-6a5c8684ac2c', // glitch-hello-react
  'cad20829-cd7f-405a-95e8-5e17b206a304', // glitch-hello-eleventy
]);
export const defaultRemixDomain = 'hello-express';
export const importFromRepoId = '33ebcb39-397a-4ab9-bc6a-868aeb7914e1';
export const getBaseProjectDomains = (isGSSEnabled) => {
  return isGSSEnabled ? ['hello-webpage', 'hello-express', 'glitch-hello-react', 'glitch-hello-eleventy'] : ['hello-webpage', 'hello-express'];
};
